import { render, staticRenderFns } from "./YearsComponent.vue?vue&type=template&id=832e71f4&scoped=true&"
import script from "./YearsComponent.vue?vue&type=script&lang=js&"
export * from "./YearsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832e71f4",
  null
  
)

export default component.exports